import { call } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestAddGroupOwnerToUserGroup (action) {
  const { groupId, userGroupId } = action.payload

  try {
    yield call(apiAction, 'AddGroupOwningGroup', {
      groupId: userGroupId,
      owningGroupId: groupId,
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  }
}
